import { render, staticRenderFns } from "./RecordsView.vue?vue&type=template&id=78f603ec&scoped=true&"
import script from "./RecordsView.vue?vue&type=script&lang=js&"
export * from "./RecordsView.vue?vue&type=script&lang=js&"
import style0 from "./RecordsView.vue?vue&type=style&index=0&id=78f603ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f603ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VImg,VRow,VTooltip})
